<select-area [selectedAreaAliasOrName]="selectedAreaAliasOrName"
    [areas]="areas"
    [isModal]="true" 
    (onCancel)="onCancel()">
</select-area>